<template>
  <div class="main">
    <div
      class="sidebar"
      v-if="isLogin && !isCurrentPagePublic"
      :class="{ 'sidebar-short': getShowSidebar }"
    >
      <div class="sidebar__logo">
        <router-link to="/">
          <img :src="logo" alt="logo" class="logo" />
        </router-link>
      </div>

      <Menu :data="navbar" :short="getShowSidebar" />
    </div>
    <div class="main-content">
      <b-navbar
        v-if="!isCurrentPagePublic"
        :class="{ notActive: isHideOnUsersPage }"
        class="navbar-main"
        type="light"
      >
        <img v-if="!isLogin" :src="logo" alt="logo" class="logo" />
        <div
          class="navbar-icons-toggle-sidebar"
          v-if="isLogin"
          @click="toggleShowSidebar"
        >
          <span
            class="material-icons icon-image-preview"
            :class="{ 'material-icons_menu-close': getShowSidebar }"
          >
            menu_open
          </span>
        </div>

        <Breadcrumbs class="navbar-breadcrumbs" v-if="isLogin" />
        <div class="navbar-user">
          <b-dropdown
            v-if="
              $can('read_all-users') ||
              $can('read_own-info_from_hr') ||
              $can('read_own-info_from_pm')
            "
            size="lg"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template slot="button-content">
              <font-awesome-icon icon="child" style="color: #fff" />
            </template>
          </b-dropdown>

          <router-link
            class="navbar__link"
            :to="{ name: 'singin' }"
            v-if="!isLogin"
            >Sign In</router-link
          >
          <router-link
            class="navbar__link"
            :to="{ name: 'singup' }"
            v-if="!isLogin"
            >Sign Up</router-link
          >

          <router-link
            class="navbar-user__name"
            :to="{ name: 'my-profile' }"
            v-if="isLogin"
          >
            {{ getUser.name }}
          </router-link>
          <div class="navbar-avatar" v-if="isLogin">
            <img :src="getUser.avatar" alt="avatar" />
          </div>

          <b-dropdown
            class="dropdown__theme-light navbar__dropdown"
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            v-if="isLogin"
          >
            <template v-slot:button-content>
              <span class="material-icons icon-image-preview vert-icon">
                more_vert
              </span>
            </template>
            <b-dropdown-item-button :href="{ name: 'users' }">
              <router-link
                class="dropdown-item-link"
                v-if="$can('read_all-users')"
                :to="{ name: 'users' }"
              >
                Users
              </router-link>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
              <router-link
                class="dropdown-item-link"
                v-if="$can('read_own-info_from_hr')"
                :to="{ name: 'users-info-hr' }"
              >
                Info from HR
              </router-link>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
              <router-link
                class="dropdown-item-link"
                v-if="$can('read_own-info_from_pm')"
                :to="{ name: 'users-info-pm' }"
              >
                Info from PM
              </router-link>
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="logOut">
              <router-link class="dropdown-item-link" :to="{ name: 'home' }">
                Log Out
              </router-link>
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </b-navbar>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>

    <!-- <GlobalModals v-if="isLogin" /> -->
    <vue-snotify></vue-snotify>
    <ConfirmModal ref="confirm" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { permissions } from '@mocks/permissions'
import ConfirmModal from '@components/modals/ConfirmModal'
import Menu from '@components/Menu/Menu'
import logo from '@/assets/logo_g.png'

export default {
  name: 'app',
  components: { ConfirmModal, Menu },
  data () {
    return {
      isLogin: !!localStorage.getItem('access_token'),
      isHideOnUsersPage: false,
      isCurrentPagePublic: false,
      navbar: null,
      permissions: permissions,
      logo
    }
  },
  mounted () {
    this.$root.$confirm = this.$refs.confirm
    this.setNavbarData()
  },
  watch: {
    isLogin: function () {
      this.setNavbarData()
    }
  },
  methods: {
    toggleShowSidebar () {
      this.$store.dispatch('toggleSidebar', !this.getShowSidebar)
    },
    setNavbarData () {
      this.navbar = {
        Home: {
          name: '/',
          label: 'Home',
          icon: 'home',
          showItem: this.$can(permissions.ReadAllHome)
        },
        Shortcuts: {
          name: '/shortcuts',
          label: 'Shortcuts',
          icon: 'bolt',
          showItem: this.$can(permissions.ReadAllHome),
          children: {
            Schedule: {
              name: '/booking-view',
              label: 'Work schedule',
              showItem: this.$can('read_own-booking_view')
            },
            SalesReport: {
              label: `Sales report`,
              items: [
                { name: '/finances-sales-report', label: 'Detailed' },
                { name: '/finances-sales-report-historical', label: 'Historical' }
              ],
              showItem: this.$can(
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability)
              )
            },
            HoursTrackingReport: {
              name: '/working-time-hours-tracking',
              label: 'Hours tracking report',
              showItem: this.$can(permissions.ReadOwnLogTimeReports)
            },
            HoursAndPaymentsPage: {
              label: 'Hours and payments report',
              items: [
                { name: '/finances-reports-hours-and-payments', label: 'Detailed' },
                { name: '/finances-reports-hours-and-payments-overview', label: 'Overview' }
              ],
              showItem:
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability)
            },
            ByPeopleAndProjects: {
              name: '/finances-reports-by-people-and-projects',
              label: 'By people and projects',
              showItem:
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability)
            },
            ProfitAndLoss: {
              label: `P&L report`,
              items: [
                { name: '/finances-reports-profit-and-loss', label: 'Detailed' },
                { name: '/finances-reports-profit-and-loss-historical', label: 'Historical' }
              ],
              showItem: this.$can(
                permissions.ReadAllFinancesReportProfitAndLoss
              )
            },
            Expenses: {
              name: '/finances-expenses',
              label: 'Expenses',
              showItem:
                this.$can(permissions.ReadAllFinancesExpenses) ||
                this.$can(permissions.ReadOwnFinancesExpenses)
            },
            Invoices: {
              name: '/finances-invoices',
              label: 'Invoices',
              showItem: this.$can(permissions.ReadAllFinancesInvoices)
            },
            BulkPayouts: {
              name: '/finances-bulk-payouts',
              label: 'Bulk Payouts (old)',
              showItem: this.$can('read_all-finances_payrolls')
            },
            Payouts: {
              name: '/finances-payouts',
              label: 'Payouts',
              showItem: this.$can('read_all-finances_payouts')
            },
            ProfileWidget: {
              name: '/available-profiles',
              label: 'Available profiles',
              showItem: this.$can(permissions.ReadAllHome)
            }
          }
        },
        Projects: {
          name: '/projects',
          label: 'Projects',
          icon: 'stars',
          showItem: this.$can('read_all-projects')
        },
        WorkSchedule: {
          label: 'Work schedule',
          name: '/work_schedule',
          icon: 'schedule',
          showItem:
            this.$can('read_own-booking_management') ||
            this.$can('read_own-booking_view'),
          children: {
            Management: {
              name: '/booking-managment',
              label: 'Management',
              showItem: this.$can('read_own-booking_management')
            },
            Schedule: {
              name: '/booking-view',
              label: 'Schedule',
              showItem: this.$can('read_own-booking_view')
            }
          }
        },
        KPI: {
          label: 'KPI',
          name: '/kpi',
          icon: 'equalizer',
          showItem:
            this.$can('read_all-kpi_reports') ||
            this.$can('read_own-kpi_reports'),
          children: {
            Reports: {
              name: '/kpi-report',
              label: 'Report',
              showItem: this.$can('read_own-kpi_reports')
            }
          }
        },
        Finances: {
          label: 'Finances',
          name: '/finances',
          icon: 'timeline',
          showItem:
            this.$can('read_all-finances_expenses_category') ||
            this.$can('read_own-finances_expenses') ||
            this.$can('read_all-finances_expenses') ||
            this.$can('read_all-finances_clients') ||
            this.$can('read_all-finances_partners') ||
            this.$can('read_own-finances_expenses_category'),
          children: {
            FinancesReports: {
              name: '/finances-reports',
              label: 'Report',
              showItem: this.$can(permissions.ReadAllFinancesInvoices),
              children: {
                SalesReport: {
                  label: `Sales report`,
                  items: [
                    { name: '/finances-sales-report', label: 'Detailed' },
                    { name: '/finances-sales-report-historical', label: 'Historical' }
                  ],
                  showItem: this.$can(
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                  )
                },
                Main: {
                  name: '/finances-reports-invoices',
                  label: 'Invoices',
                  showItem: this.$can(permissions.ReadAllFinancesInvoices)
                },
                Expenses: {
                  name: '/finances-reports-expenses',
                  label: 'Expenses',
                  showItem: this.$can(permissions.ReadAllFinancesExpenses)
                },
                Payrolls: {
                  name: '/finances-reports-payrolls',
                  label: 'Payrolls',
                  showItem: this.$can(permissions.ReadAllFinancesExpenses)
                },
                ProfitAndLoss: {
                  label: `P&L`,
                  items: [
                    { name: '/finances-reports-profit-and-loss', label: 'Detailed' },
                    { name: '/finances-reports-profit-and-loss-historical', label: 'Historical' }
                  ],
                  showItem: this.$can(
                    permissions.ReadAllFinancesReportProfitAndLoss
                  )
                },
                ProfitAndLossCalculator: {
                  name: '/finances-reports-profit-and-loss-calculator',
                  label: 'Profit and loss calculator',
                  showItem: this.$can(
                    permissions.ReadAllFinancesReportProfitAndLoss
                  )
                },
                ByPeopleAndProjects: {
                  name: '/finances-reports-by-people-and-projects',
                  label: 'By people and projects',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                },
                Balances: {
                  name: 'finances-reports-balances',
                  label: 'Balances',
                  showItem:
                    this.$can(permissions.ReadAllFinancesReportBalances)
                },
                HoursAndPaymentsPage: {
                  label: 'Hours and payments report',
                  items: [
                    { name: '/finances-reports-hours-and-payments', label: 'Detailed' },
                    { name: '/finances-reports-hours-and-payments-overview', label: 'Overview' }
                  ],
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                }
              }
            },
            Expenses: {
              name: '/finances-expenses',
              label: 'Expenses',
              showItem:
                this.$can(permissions.ReadAllFinancesExpenses) ||
                this.$can(permissions.ReadOwnFinancesExpenses),
              children: {
                Main: {
                  name: '/finances-expenses',
                  label: 'Main',
                  showItem:
                    this.$can(permissions.ReadAllFinancesExpenses) ||
                    this.$can(permissions.ReadOwnFinancesExpenses)
                },
                Categories: {
                  name: '/finances-expenses-categories',
                  label: 'Categories',
                  showItem:
                    this.$can(permissions.ReadAllFinancesExpensesCategory) ||
                    this.$can(permissions.ReadOwnFinancesExpensesCategory)
                }
              }
            },
            FinancesInvoices: {
              name: '/finances-invoices',
              label: 'Invoices',
              showItem:
                this.$can(permissions.ReadAllFinancesInvoices) ||
                this.$can(permissions.ReadOwnFinancesInvoices),
              children: {
                Main: {
                  name: '/finances-invoices',
                  label: 'Invoices',
                  showItem: this.$can(permissions.ReadAllFinancesInvoices)
                },
                FinancesProjectSpecialisation: {
                  name: '/finances-invoices-project-specialisations',
                  label: 'Project specialisations',
                  showItem: this.$can(
                    permissions.ReadAllFinancesProjectSpecialisations
                  )
                }
              }
            },
            FinancesBankDetails: {
              name: '/finances-bank-details',
              label: 'Bank details',
              showItem:
                this.$can(permissions.ReadAllFinancesOwnBankDetails) ||
                this.$can(permissions.ReadOwnFinancesOwnBankDetails),
              children: {
                Main: {
                  name: 'finances-bank-details',
                  label: 'Own',
                  showItem: this.$can(
                    permissions.ReadAllFinancesOwnBankDetails
                  )
                },
                FinancesClientsBankDetails: {
                  name: '/finances-bank-details-clients',
                  label: 'Clients',
                  showItem: this.$can(
                    permissions.ReadAllFinancesClientBankDetails
                  )
                },
                FinancesBankDetailsCards: {
                  name: '/finances-bank-details-cards',
                  label: 'Cards',
                  showItem: this.$can(
                    permissions.ReadAllFinancesOwnBankDetails
                  )
                },
                FinancesBankDetailContractors: {
                  name: '/finances-bank-details-contractors',
                  label: 'Contractors',
                  showItem: this.$can(
                    permissions.ReadAllFinancesContractorBankDetails
                  )
                },
                FinancesBankDetailPartners: {
                  name: '/finances-bank-details-partners',
                  label: 'Partners',
                  showItem: this.$can(
                    permissions.ReadAllFinancesPartnerBankDetails
                  )
                }
              }
            },
            Clients: {
              name: '/finances-clients',
              label: 'Clients',
              showItem: this.$can('read_all-finances_clients')
            },
            Partners: {
              name: '/finances-partners',
              label: 'Partners',
              showItem: this.$can('read_all-finances_partners')
            },
            TaxTypes: {
              name: '/finances-tax-types',
              label: 'Tax types',
              showItem: this.$can('read_all-finances_tax_types')
            },
            Compensations: {
              name: '/finances-compensations',
              label: 'Compensations',
              showItem: this.$can('read_all-finances_compensations')
            },
            BulkPayouts: {
              name: '/finances-bulk-payouts',
              label: 'Bulk Payouts (old)',
              showItem: this.$can('read_all-finances_payrolls')
            },
            Payouts: {
              name: '/finances-payouts',
              label: 'Payouts',
              showItem: this.$can('read_all-finances_payouts')
            },
            SalesChannels: {
              name: 'finances-sales-channels',
              label: 'Sales channels',
              showItem: this.$can('read_all-finances_payrolls')
            }
          }
        },
        WorkingTime: {
          name: '/working-time',
          label: 'Working time',
          icon: 'history',
          showItem: this.$can(permissions.ReadOwnLogTimeReports),
          children: {
            Reports: {
              name: '/working-time',
              label: 'Report',
              showItem: this.$can(permissions.ReadOwnLogTimeReports)
            },
            Management: {
              name: '/working-time-management',
              label: 'Management',
              showItem: this.$can(permissions.UpdateAllLogTimeReports)
            },
            HoursTrackingReport: {
              name: '/working-time-hours-tracking',
              label: 'Hours tracking report',
              showItem: this.$can(permissions.ReadOwnLogTimeReports)
            }
          }
        },
        Backlog: {
          label: 'Backlog',
          name: '/backlog',
          icon: 'library_books',
          showItem:
            this.$can('read_own-backlog_reports') ||
            this.$can('read_own-backlog_history'),
          children: {
            Reports: {
              name: '/backlog-time-report',
              label: 'Report',
              showItem: this.$can('read_own-backlog_reports')
            }
          }
        },
        Units: {
          label: 'Units',
          name: '/units',
          icon: 'assignment_turned_in',
          showItem:
            this.$can('read_own-units') ||
            this.$can('read_own-unit_management'),
          children: {
            Management: {
              name: '/unit-management',
              label: 'Management',
              showItem: this.$can('read_own-unit_management')
            },
            Units: {
              name: '/units',
              label: 'Units',
              showItem: this.$can('read_own-units')
            }
          }
        },
        Misc: {
          label: 'Misc.',
          name: '/misc.',
          icon: 'offline_bolt',
          showItem:
            this.$can('read_all-permission') ||
            this.$can('read_all-not_estimated') ||
            this.$can('create-skills') ||
            this.$can('read_all-system_operations'),
          children: {
            SystemOperations: {
              name: '/system-operations',
              label: 'System operations',
              showItem: this.$can('read_all-system_operations')
            },
            Permission: {
              name: '/permission',
              label: 'Permission',
              showItem: this.$can('read_all-permission')
            },
            NotEstimated: {
              name: '/not-estimated',
              label: 'Not estimated',
              showItem: this.$can('read_all-not_estimated')
            },
            NotBudget: {
              name: '/not-budget',
              label: 'Not budget',
              showItem: this.$can('read_all-not_estimated')
            },
            Skills: {
              name: '/skills',
              label: 'Skills',
              showItem: this.$can('create-skills')
            },
            // Logs: {
            //   name: '/telescope',
            //   label: 'Logs',
            //   showItem: this.$can('read_all-kpi_reports')
            // },
            Holidays: {
              name: '/holidays',
              label: 'Holidays',
              showItem: this.$can('read_all-system_operations')
            },
            Backlog: {
              name: '/backlog-not-done-and-estimated',
              label: 'Backlog',
              showItem: true
            }
          }
        },
        Notifications: {
          label: 'Notification',
          name: '/notifications',
          icon: 'schedule',
          showItem: this.$can(permissions.ReadAllHome),
          children: {
            Telegram: {
              name: '/notifications/telegram',
              label: 'Telegram',
              showItem: this.$can(permissions.ReadAllHome),
              children: {
                Partners: {
                  name: '/notifications/telegram/partners',
                  label: 'Partners',
                  showItem: this.$can(permissions.ReadAllHome)
                },
                Contractors: {
                  name: '/notifications/telegram/contractors',
                  label: 'Contractors',
                  showItem: this.$can(permissions.ReadAllHome)
                },
                CampaignsForPartners: {
                  name: '/notifications/telegram/campaigns-for-partners',
                  label: 'Campaigns for partners',
                  showItem: this.$can(permissions.ReadAllHome)
                },
                CampaignsForContractors: {
                  name: '/notifications/telegram/campaigns-for-contractors',
                  label: 'Campaigns for contractors',
                  showItem: this.$can(permissions.ReadAllHome)
                }
              }
            }
          }
        }
      }
    },
    logOut () {
      this.$api.auth.logout()
    },

    isHideHeader () {
      if (this.$router.history.current.name === 'users') {
        this.isHideOnUsersPage = true
      } else {
        this.isHideOnUsersPage = false
      }
    },

    isPublicPage () {
      const publicPages = ['available-profiles']
      this.isCurrentPagePublic = publicPages.includes(this.$router.history.current.name)
    }
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      isActive: 'isActive',
      getUser: 'getUser',
      getShowSidebar: 'getShowSidebar'
    })
  },

  async created () {
    await this.$api.roles.getRoles()
    if (localStorage.getItem('access_token')) {
      await this.$api.auth.authUser()
    }
    this.axios.interceptors.response.use(undefined, (err) => {
      return new Promise((resolve, reject) => {
        if (err.response.status === 401) {
          // if you ever get an unauthorized, logout the user
          this.$router.push({ name: 'singin' })
          localStorage.removeItem('access_token')
          // you can also redirect to /login if needed !
        }
        throw err
      })
    })
    this.axios.interceptors.request.use(undefined)

    this.isHideHeader()
    this.isPublicPage()
  },
  // created() {
  //     this.axios.interceptors.response.use(undefined, (err) => {
  //         return new Promise( (resolve, reject) => {
  //             if (err.response.status === 401) {
  //                 // if you ever get an unauthorized, logout the user
  //                 this.$router.push({name: 'singin'});
  //                 localStorage.removeItem('access_token');
  //                 // you can also redirect to /login if needed !
  //             }
  //             throw err;
  //         });
  //     });
  //     this.axios.interceptors.request.use(undefined,)
  // },
  updated () {
    this.isLogin = !!localStorage.getItem('access_token')
    this.isHideHeader()
    this.isPublicPage()
  }
}
</script>

<style
  src="../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"
></style>
<style lang="scss">
@import "../sass/app.scss";
</style>
<style scoped>
/*.navbar {*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*  min-height: 54px;*/
/*}*/

.onUser {
  background: #ff0000;
}

/*.navbar div > * {*/
/*  padding-left: 10px;*/
/*  padding-right: 10px*/
/*}*/

/*.navbar li {*/
/*  list-style: none;*/
/*  display: inline-block;*/
/*}*/

/*@media (max-width: 1087px) {*/
/*  .navbar {*/
/*    display: flex;*/
/*    justify-content: space-between;*/
/*    font-size: 14px;*/
/*  }*/

/*  .navbar div > * {*/
/*    padding-left: 5px;*/
/*    padding-right: 5px;*/
/*  }*/
/*}*/

/*@media (min-width: 1088px) and (max-width: 1410px) {*/
/*  !*.navbar {*!*/
/*  !*  display: flex;*!*/
/*  !*  justify-content: space-between;*!*/
/*  !*  font-size: 14px;*!*/
/*  !*}*!*/

/*  .user-section {*/
/*    margin: 0;*/
/*  }*/

/*  .navbar div > * {*/
/*    padding-left: 10px;*/
/*    padding-right: 10px*/
/*  }*/
/*}*/
</style>
<style>
.navbar .nav-link {
  color: white;
}
</style>
